const canUseDOM = () => {
    if (typeof window === 'undefined' || !window.document || !window.document.createElement) {
        return false;
    }
    return true;
};

export const callZendeskApi = (...args: string[]) => {
    if (canUseDOM() && (window as any).zE) {
        (window as any).zE.apply(null, args);
    } else {
        console.warn('Zendesk is not initialized yet');
    }
};
